// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".messenger{margin:0 auto;padding:64px}.messenger::after{clear:both;content:\"\";display:block}.messenger .messenger__menu{width:calc(25% - 40px);float:left;margin-left:32px}@media(min-width: 1920px){.messenger .messenger__menu{width:calc(18.75% - 38px);float:left;margin-left:32px}}", ""]);
// Exports
module.exports = exports;
